interface Payload {
  accessGroupId: string;
  assetsToBeAdded: string[];
  assetsToBeDeleted: string[];
}

export const createBatches = (payload: Payload, BATCH_SIZE: number) => {
  if (BATCH_SIZE <= 0) {
    throw new RangeError('Batch size has to be over 0');
  }

  const payloads: Payload[] = [];
  const payloadsToAdd: Payload[] = payload.assetsToBeAdded.reduce<Payload[]>(
    (acc, assetId, index) => {
      const batchNr = Math.floor(index / BATCH_SIZE);
      acc[batchNr] = acc[batchNr] || {
        ...payload,
        assetsToBeAdded: [],
        assetsToBeDeleted: [],
      };
      acc[batchNr].assetsToBeAdded.push(assetId);

      return acc;
    },
    []
  );
  const payloadsToDelete: Payload[] = payload.assetsToBeDeleted.reduce<Payload[]>(
    (acc, assetId, index) => {
      const batchNr = Math.floor(index / BATCH_SIZE);
      acc[batchNr] = acc[batchNr] || {
        ...payload,
        assetsToBeAdded: [],
        assetsToBeDeleted: [],
      };
      acc[batchNr].assetsToBeDeleted.push(assetId);

      return acc;
    },
    []
  );
  payloadsToAdd.forEach((item) => payloads.push(item));
  payloadsToDelete.forEach((item) => payloads.push(item));
  return payloads;
};
